module.exports = __webpack_public_path__ + "static/media/Data_insight_2-1.0b8f1f05.svg";